export const LogoLink = () => {
    const logoLink = () => {
        return '/';
    };

    return (
        <>
            <div className='logoWrapper'>
                <a
                    href={logoLink()}
                    className='logo no-print'
                >
                    <img
                        src='/images/broker/logo.webp.html'
                        alt='Builder Finance'
                    />
                </a>
            </div>
        </>
    );
};
